<footer>
    <span>© {new Date().getFullYear()} Hanna Tiina Pekk</span>
</footer>

<style>
footer {
    width: 100%;
    padding: 3rem 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 6rem;
    border-top: 1px solid #e0ddd9;
}
span {
    font-size: 0.7rem;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #aaa;
}
</style>
